import { ICountryService } from '../../../../request/requestList/services/countryService';
import { Country } from '../../../../request/requestList/models/country';
import { IPackageTypeService } from '../../../../request/requestDetailEdit/directives/packageDialog/services/packageTypeService';
import { PackageType } from '../../../../request/requestDetailEdit/directives/packageDialog/models/packageType';
import '../../../../../core/directives/readOnlyText/readOnlyTextDirective';
import '../templates/ruleDialog.scss';
import { Rule } from '../../../models/rule';
import { OperatorTypeEnumList } from '../models/operatorTypeEnum';
import { RuleActionEnumList } from '../models/ruleActionEnum';
import { RulesService } from '../../../rulesService'
import { INotificationService } from '../../../../../core/notificationService';
import { IRegionService } from '../../../../request/addRequest/directives/consigneeSearch/services/regionService';
import { Region } from '../../../../request/addRequest/directives/consigneeSearch/models/region';


export default class RuleDialogController {

    static $inject = ['$mdDialog', '$q', 'NotificationService', 'countryService', 'packageTypeService', 'rulesService', 'RegionService', '$scope'];

    _rule: Rule;
    isNewRule: boolean;
    isLoading: boolean;
    editIndex: number;

    _countries: Country[];
    _packageTypes: PackageType[];
    _originCities: string[];
    _originLocations: string[];
    _usRegions: Region[];
    _regionCodes: string[];
    operatorTypes = OperatorTypeEnumList;
    ruleActionTypes = RuleActionEnumList;

    constructor(private _$mdDialog: ng.material.IDialogService,
        private $q: ng.IQService,
        private _notificationService: INotificationService,
        private _countryService: ICountryService,
        private _packageTypeService: IPackageTypeService,
        private _rulesService: RulesService,
        private _regionService: IRegionService,
        private $scope: ng.IScope
    ) {
        $scope.$watch(() => this._rule && this._rule.destination, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                if (newVal === 'US') {
                    this.loadUsRegions();
                } else {
                    this._usRegions = [];
                }
            }
        });
    }

    $onInit(): void {
        this.populateInitialValues();       
    }

    populateInitialValues(): void {
        this.isLoading = true;
        const deferred = this.$q.defer();

        this.$q.all([this.populateCountries(), this.populatePackageTypes(), this.populateOriginCities(), this.populateOriginLocations(), this.populateRegionCodes(), this.populateRule()])
            .then((values) => {

                this.handleGetCountries(values[0]);
                this.handleGetPackageTypes(values[1]);
                this.handleOriginCities(values[2]);
                this.handleOriginLocations(values[3]);  
                this.handleRegionCodes(values[4]); 
                if (this.isNewRule === false) {
                    debugger
                    this.handleGetRule(values[5]);
                }
                else {
                    this._rule = new Rule(undefined);
                }
                this.isLoading = false;
            })
            .catch((response) => {
                deferred.reject(this.getErrorReason(response.status));  
                this.isLoading = false;
            });
    }

    private loadUsRegions(): void {
        this._regionService.getRegionsByCountry('US').then(regions => {
            this._usRegions = regions;
        });
    }

    private populateCountries(): ng.IPromise<Country[]> {
        const deferred = this.$q.defer<Country[]>();
        this._countryService.getCountryList()
            .then((countries) => {
                deferred.resolve(countries);
            })
            .catch((response) => {
                deferred.reject(response);
            });
        return deferred.promise;
    }

    private populatePackageTypes(): ng.IPromise<PackageType[]> {
        const deferred = this.$q.defer<PackageType[]>();
        this._packageTypeService.getPackageTypes()
            .then((packageTypes) => {
                deferred.resolve(packageTypes);
            })
            .catch((response) => {
                deferred.reject(response);
            });
        return deferred.promise;
    }

    private populateOriginCities(): ng.IPromise<string[]> {
        const deferred = this.$q.defer<string[]>();
        this._rulesService.getOriginCities()
            .then((originCities) => {
                deferred.resolve(originCities);
            })
            .catch((response) => {
                deferred.reject(response);
            });
        return deferred.promise;
    }

    private populateOriginLocations(): ng.IPromise<string[]> {
        const deferred = this.$q.defer<string[]>();
        this._rulesService.getOriginLocations()
            .then((originLocations) => {
                deferred.resolve(originLocations);
            })
            .catch((response) => {
                deferred.reject(response);
            });
        return deferred.promise;
    }

    private populateRule(): ng.IPromise<Rule> {
        const deferred = this.$q.defer<Rule>();
        this._rulesService.getRuleById(this.editIndex)
            .then((rule) => {
                deferred.resolve(rule);
            })
            .catch((response) => {
                deferred.reject(response);
            });
        return deferred.promise;
    }

    private populateRegionCodes(): ng.IPromise<string[]> {
        const deferred = this.$q.defer<string[]>();
        this._rulesService.getRegionCodes()
            .then((regionCodes) => {
                deferred.resolve(regionCodes);
            })
            .catch((response) => {
                deferred.reject(response);
            });
        return deferred.promise;
    }

    private getErrorReason(status: any): string {
        var value = 'error';
        if (status !== undefined && status.toString() === "401")
            value = 'timeout';
        return value;
    }



    cancel(): void {
        this._$mdDialog.cancel();
    }


    private save(): void {
        this.isLoading = true;
        this.transformFieldsToNull(this._rule);
        if (this.isNewRule) {
            this._rulesService.add(this.rule)
                .then(v => this.handleSaveSuccess(v))
                .catch((err: unknown) => { });

        }
        else {
            this._rulesService.update(this.rule)
                .then(v => this.handleSaveSuccess(v))
                .catch((err: unknown) => { });
        }

    }
    private handleSaveSuccess(result: any): void {

        this.isLoading = false;

        this._$mdDialog.hide();
    }



    handleGetCountries(options: any) {
        this._countries = options;
    }

    handleGetPackageTypes(options: any) {
        this._packageTypes = options;
    }

    handleOriginCities(options: any) {
        this._originCities = options;
    }

    handleOriginLocations(options: any) {
        this._originLocations = options;
    }

    handleRegionCodes(options: any) {
        this._regionCodes = options;
    }

    private handleGetRule(rule: Rule): void {
        if (rule === undefined || rule === null) {
            this._notificationService.showToastWithMentionedDelay("Something went wrong", 5000);
        } else {
            this.transformFieldsToNull(rule);
            this._rule = rule;
        }

    }
    private transformFieldsToNull(rule: Rule): void {
        if (rule) {
            rule.originCity = rule.originCity === '' || rule.originCity === 'None' ? null : rule.originCity;
            rule.destinationRegionCode = rule.destinationRegionCode === '' || rule.destinationRegionCode === 'None' ? null : rule.destinationRegionCode;
                       
        }
    }

    get usRegions(): Region[] {
        return this._usRegions;
    }

    get countries(): Country[] {
        return this._countries;
    }
    get packageTypes(): PackageType[] {
        return this._packageTypes;
    }

    get rule(): Rule {
        return this._rule;
    }
    get originCities(): string[] {
        return this._originCities;
    }
    get originLocations(): string[] {
        return this._originLocations;
    }
    get regionCodes(): string[] {
        return this._regionCodes;
    }

    isValidForm(): boolean {
        var isValid = false;
        if (this.rule !== undefined) {
            isValid = ((this.rule.origin !== undefined && this.rule.origin !== null) ||
                (this.rule.originCity !== undefined && this.rule.originCity !== null) ||
                (this.rule.originLocation !== undefined && this.rule.originLocation !== null) ||
                (this.rule.destination !== undefined && this.rule.destination !== null) ||
                (this.rule.packageType !== undefined && this.rule.packageType !== null) ||
                ((this.rule.packageWeightOperator !== undefined && this.rule.packageWeightOperator !== null) && (this.rule.packageWeight !== undefined && this.rule.packageWeight !== null)) ||
                ((this.rule.dollarValueOperator !== undefined && this.rule.dollarValueOperator !== null) && (this.rule.dollarValue !== undefined && this.rule.dollarValue !== null)));
        }
        return isValid;
    }

}

angular
    .module('deliveryCreate.app')
    .controller('RuleDialogController', RuleDialogController)
    .component('ruleDialog',
        {
            template: require('../templates/ruleDialog.html'),
            controller: RuleDialogController,
            controllerAs: 'vm',
            bindings: {
                isNewRule: '=',
                editIndex: '='
            }
        });


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/rules/directives/rulesDialog/controllers/ruleDialogController.ts
 **/